<template>
    <div class="home">
     
      <TabsInspeccionComponent />
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import TabsInspeccionComponent from '@/components/TabsInspeccionComponent.vue'
  
  export default {
   // name: 'UserView',
    components: {
        TabsInspeccionComponent
    }
  }
  </script>